import React from 'react';
import './App.css';
import HomeScreen from './components/HomeScreen/HomeScreen';

function App() {
  return (
    <div className='App'>
      <HomeScreen />
    </div>
  );
}

export default App;
